import { Box, Card, CardContent, List, ListItem, ListItemText, TextField, Typography } from '@mui/material';
import React, { useState } from 'react'
import DropdownfromDatabaseList from '../../CustomComponant/DropdownfromDatabaseList';
import apiClient from '../../BaseUrl/apiClient';
import { useNavigate } from 'react-router-dom';
import TokenService from '../../service/TokenService';
import EncryptService from '../../service/EncryptionService';

function MergeIndent() {


    const tokenServiceDetails = TokenService.getUserDetails();
    const logineuname = tokenServiceDetails?.uname;
    const ip = EncryptService.decrypt(sessionStorage.getItem("token1"));

const [poNumber, setPONumber] = useState("");
const [qty,setQty]=useState(0);
const [val,setVal]=useState(0);
const [poItemName,setPOItemName]=useState("");
const [poIndentid,setPOIndentID]=useState("");
  const [list1, setList1] = useState([]);
  const [list2, setList2] = useState([]);
  const navigate = useNavigate();
    const getPOData = async () => {
      if (!poNumber || poNumber.trim() === "") return;
        try {
          const response = await apiClient.post("/MergeIndentListbyPO", {
            ponumber: poNumber,
           
          });
          const data = response.data;
       //   console.log(data[0]);
          setList1(response.data);
          setQty(data[0].POQty);
          setVal(data[0].POValue);
          setPOItemName(data[0].POItemName);
          setPOIndentID(data[0].indentlist);
      

        } catch (error) {
            setQty(0);
            setVal(0);
            setPOItemName('');
            
        }
      };



const sortItems = (items) =>
    [...items].sort((a, b) => a.IndentNumber.localeCompare(b.IndentNumber));

const handleTransferToSelected = (item) => {
    const updatedList1 = list1.filter(
      (i) => i.IndentNumber !== item.IndentNumber
    );
    const updatedList2 = [...list2, item];
    setList1(sortItems(updatedList1));
    setList2(sortItems(updatedList2));
    setQty((qty) => Number(qty) + Number(item.IndentQty));
    setVal((val) => Number(val) + Number(item.IndentValue));
   };

const handleTransferToAvailable = (item) => {
    const updatedList2 = list2.filter(
      (i) => i.IndentNumber !== item.IndentNumber
    );
    const updatedList1 = [...list1, item];
    setList1(sortItems(updatedList1));
    setList2(sortItems(updatedList2));
    setQty((qty) => Number(qty) - Number(item.IndentQty));
    setVal((val) => Number(val) - Number(item.IndentValue));

  };
  const handleClose = () => {
    navigate("../", { replace: true });
  };


  const UpdatPO = async (e) => {
    e.preventDefault();
     if (poItemName.length > 2) {
        const mergeindentList =
        list2.length > 0
          ? [...list2.map((item) => item.id), poIndentid].join(",")
          : poIndentid;
        
      
      try {
        await apiClient.post("/updateMergedData", {
          uname: logineuname,
          ponumber: poNumber,
          mvalue: val,
          mqty: qty,
          mlist: mergeindentList,
          vip: ip,
          
        });
        
        setPOItemName("");
        setQty(0);
        setVal(0);
        setPONumber("");
        setPOIndentID("");
        setList1([]);
        setList2([]);

      } catch (error) {
        console.error("Error updating Merge Data:", error);
      }




        
        


    }
  };








  return (
    <div >
      {/* <SriyanshCardHeader Title="Update User" /> */}
      <Card className="Formcard ">
      <div className="input-groupHeading">
      Merge Indent

            </div>
        <CardContent>
          <div className="row">
          <div className="container">
            <div className="input-group">
              <TextField
                label="PO Number"
                variant="outlined"
                size="small"
                value={poNumber}
               onChange={(e) => setPONumber(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    getPOData();
                   
                //    fetchUserData();
                  }
                }}
                fullWidth
                disabled={!!poItemName}
               // error={!!errors.username}
              //  helperText={errors.username}
              //  inputProps={{ maxLength: 10 }}
              />

    
            </div>

            <div className="input-group">
              <TextField
                label="Item Name"
                variant="outlined"
                value={poItemName}
                size="small"
                fullWidth
                disabled="true"
               // error={!!errors.username}
              //  helperText={errors.username}
              //  inputProps={{ maxLength: 10 }}
              />

    
            </div>



            </div>


            <div className="container">

             <div className="input-group">
              <TextField
                label="Total Value"
                variant="outlined"
                size="small"
               value={val}
              //  onChange={(e) => setUsername(e.target.value.toLowerCase())}
               fullWidth
               disabled="true"
              />
            </div>
            
            <div className="input-group">
              <TextField
               label="Total Quantity"
                variant="outlined"
                size="small"
               value={qty}
              //  onChange={(e) => setUsername(e.target.value.toLowerCase())}
               fullWidth
               disabled="true"
              />
            </div>
           </div>
           
         

         {/* <div className="container"> */}
            {/* <div className="input-group">
              <DropdownfromDatabaseList
              //  Options={roles} //ARRAY COMPONENT
              //  option={role} // VALUE VARIABLE
              //  setOptionValue={setRole} //SET VALUE VARIBALE
                DisplayItem1="role"
                DisplayItem2="id"
              />
            </div> */}

           
              <div className="container">
                {/* List 1: Available Consignees */}
                <div className="input-group">
                  <Box
                    sx={{
                      width: "100%",
                      border: "1px solid #ccc",
                      borderRadius: 2,
                      overflow: "auto",
                      maxHeight: 300, // Optional scrollable height
                    }}
                  >
                    <Typography
                      variant="h6"
                      component="div"

                      sx={{
                        backgroundColor: "#f0f0f0",
                        padding: "8px",
                        borderBottom: "1px solid #ccc",
                        textAlign: "center",
                        
                      }}
                    >
                      Available Indent
                    </Typography>
                    <List>
                      {list1.map((item) => (
                        <ListItem
                          key={item.IndentNumber}
                          button
                          onClick={() => handleTransferToSelected(item)}
                          
                        >
                         <ListItemText
        primary={`${item.IndentNumber} | Quantity: ${item.IndentQty} | Value: ${item.IndentValue} `}
        secondary={`ID: ${item.id} `}
      />
    </ListItem>
                      ))}
                    </List>
                  </Box>
                </div>

                {/* List 2: Selected Consignees */}
                <div className="input-group">
                  <Box
                    sx={{
                      width: "100%",
                      border: "1px solid #ccc",
                      borderRadius: 2,
                      overflow: "auto",
                      maxHeight: 300, // Optional scrollable height
                    }}
                  >
                    <Typography
                      variant="h6"
                      component="div"
                      sx={{
                        backgroundColor: "#f0f0f0",
                        padding: "8px",
                        borderBottom: "1px solid #ccc",
                        textAlign: "center",
                      }}
                    >
                      Selected Indent
                    </Typography>
                    <List>
                      {list2.map((item) => (
                        <ListItem
                          key={item.IndentNumber}
                          button
                          onClick={() => handleTransferToAvailable(item)}
                        >
                        
                           <ListItemText
        primary={`${item.IndentNumber} | Quantity: ${item.IndentQty} | Value: ${item.IndentValue} `}
        secondary={`ID: ${item.id} `}
      />
    </ListItem>
                      ))}
                    </List>
                  </Box>
                </div>
              </div>
           

           
              {/* <div className="input-group">
                <DropdownfromDatabaseList
                // Options={consignees}
                 // option={consignee}
                //  setOptionValue={setConsignee}
                  DisplayItem1="Shop"
                  DisplayItem2="ConsigneeCode"
                  showKeyInLabel={true}
                />
              </div>
           
          </div> */}

          <>
            <div
              className="container flex"
              style={{
                display: "flex",
                paddingLeft: "40px",
                paddingRight: "40px",
                justifyContent: "space-between", // Distributes space between items
              }}
            >
              <button
                className="button button1"
                type="button" // Updated type attribute to "button"
              onClick={UpdatPO}
                title="Click for user update"
               // disabled={updateBtn}
              >
                Merge Indent
              </button>

              <button
                className="button button1"
                type="button" // Updated type attribute to "button"
                onClick={handleClose}
                title="Click for Data Save"
                style={{ backgroundColor: "red", color: "white" }}
              >
                Close
              </button>
            </div>
          </>
          </div>
        </CardContent>
      </Card>
        </div>
  )
}

export default MergeIndent